import { Letter } from 'state/letter/types'

import { CellProps } from 'components/ui'

import { Wrapper, Title, Value } from '../Style'

export function FullName({ row }: CellProps<Letter>) {
  const { firstName, lastName } = row.original

  return (
    <Wrapper area='Name'>
      <Title>Name</Title>
      <Value>
        {firstName} {lastName}
      </Value>
    </Wrapper>
  )
}
